<template>
  <div class="wrap">
    <div class="banner">
      <img src="@/assets/other/product-center.jpg" style="width: 100%" alt="" />
    </div>
    <Nav title="产品中心" />
    <div class="pagew content">
      <div class="type">
        <div class="title">
          <span class="line"></span>
          噻吩并噻吩类
        </div>
        <div class="bottom-info">
          <div class="item">
            <img src="@/assets/other/element/4.jpg" alt="" />
            <div class="txt">
              3-bromothieno[3,2-b]thinophene<br />
              3-溴噻吩[3,2-B]噻吩<br />
              CAS NO:25121-83-9
            </div>
          </div>
          <div class="item">
            <img src="@/assets/other/element/5.jpg" alt="" />
            <div class="txt">
              3-hexylthieno[3,2-b]thiophene<br />
              3-己基-噻吩并[3,2-B]噻吩<br />
              CAS NO:880088-89-1
            </div>
          </div>
          <div class="item">
            <img src="@/assets/other/element/7.jpg" alt="" />
            <div class="txt">
              3-nonylthieno[3,2-b]thiophene<br />
              3-壬基-噻吩并[3,2-B]噻吩<br />
              CAS NO:763114-94-9
            </div>
          </div>
          <div class="item">
            <img src="@/assets/other/element/8.jpg" alt="" />
            <div class="txt">
              3-undecylthieno[3,2-b]thiophene<br />
              3-十一烷基噻吩并[3,2-B]噻吩<br />
              CAS NO:950223-97-9
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer :show="false" />
  </div>
</template>

<script>
import { getWorkList, getWorkYearList, getProductListAll } from "@/api/api.js";
import Nav from "../../components/Nav/Nav.vue";
export default {
  name: "index",
  components: { Nav },
  data() {
    return {
      jsonData: [],
      imgList: [],
      url: "/Work",
      pageSize: 100,
      currentPage: 1,
      total: 0,
      activeIndex: "1",
      paramsYear: {
        workCompetition: this.$route.query.key
      }
    };
  },
  /*  created() {
    // this.getList();
    this.getWorkYearList(this.paramsYear);
    this.getProductListAll();
  }, */
  methods: {
    getProductListAll() {
      getProductListAll({ state: "Y" }).then(res => {
        this.jsonData = res.data.rows || [];
        console.log(res);
      });
    },
    getList() {
      getWorkList({}).then(res => {
        // this.imgList = res.data || [];
        console.log(res);
      });
    },
    getWorkYearList(paramsYear) {
      getWorkYearList(paramsYear).then(res => {
        this.imgList = res.data.rows || [];

        console.log(res);
      });
    },
    handleSelect(index) {
      console.log(index);
      this.getList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    toPage(item, index) {
      this.$router.push({
        path: "Work/wordDetail",
        query: {
          id: index,
          title: item.workTitle,
          info: item
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.banner {
  margin-top: 82px;
}
.content {
  margin-top: 20px;
  .type {
    margin-top: 50px;
    .title {
      position: relative;
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      background-color: #5197d5;
      color: #fff;
      .line {
        display: inline-block;
        position: absolute;
        top: 22px;
        left: 20px;
        width: 15px;
        height: 3px;
        background-color: #fff;
      }
    }

    .bottom-info {
      display: flex;
      // flex-wrap: wrap;
      justify-content: stretch;
      .item {
        height: 350px;
        border: 2px solid #5197d5;
        margin-top: 20px;
        margin-right: 50px;
        img {
          width: 250px;
          height: 200px;
          margin: 0 30px;
        }

        .txt {
          width: 310px;
          height: 100px;
          margin-top: 50px;
          padding-top: 5px;
          line-height: 30px;
          font-size: 18px;
          text-align: center;
          background-color: #5197d5;
          color: #fff;
        }
      }
    }
  }
}
.select {
  height: 80px;
  width: 60%;
  margin: 0 auto;
}
.el-menu-item.is-active {
  border-bottom: 2px solid red !important;
  color: red !important;
  font-weight: bold;
}

.el-menu-item {
  padding: 0 43px;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.img-title {
  text-align: center;
}

.wrap {
  text-align: left;
  width: 100%;

  .banner {
    width: 100%;
    z-index: -2;
  }

  .imgbox {
    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .boxitem {
        width: 25%;
        padding-bottom: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .onde {
          width: 90%;
          height: 320px;

          .top {
            position: relative;

            .ditu {
              width: 100%;
              height: 45px;
              line-height: 45px;
              text-align: center;
              top: 175px;
              color: #ffffff;
              font-size: 14px;
              position: absolute;
              background: url("../../assets/workimg/ditu.png") no-repeat;
              background-position: center;
            }
          }

          .cont {
            font-size: 14px;
            text-align: center;
            background-color: #f5f5f5;
            padding: 20px 0;
          }

          .bottom {
            width: 100%;
            background-color: #f5f5f5;
            padding: 10px 0;
            display: flex;
            font-size: 14px;
            justify-content: space-around;
            align-items: center;

            div {
              // width: 50%;
              text-align: right;
              // padding-right: 10px;
            }
          }
        }
      }

      .boxitem:hover {
        border-bottom: 1px solid red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Work/list1.vue